import { gql } from 'graphql-request';

export const getInternetSecurityLinkQuery = gql`
  query getInternetSecurityLink($billingCustomerId: String!, $assignedProductId: String!) {
    getInternetSecurityLink(billingCustomerId: $billingCustomerId, assignedProductId: $assignedProductId) {
      link
    }
  }
`;
